import { __decorate, __metadata, __param } from "tslib";
import dayjs from 'dayjs';
import { inject, injectable } from 'inversify';
import { Symbols } from '@/symbols';
const extra = { from: 'Analytics' };
let CmsApi = class CmsApi {
    constructor(urls, http) {
        this.urls = urls;
        this.http = http;
        /**
         * 获取Multiply array params
         * @returns
         */
        this.getBasicList = () => {
            return this.http.get({
                url: this.urls.getBasicList,
                params: extra,
                data: {
                    ts: dayjs(),
                },
            });
        };
        /**
         * 获取Model 分类数组
         * @returns
         */
        this.getModelList = () => {
            const url = this.urls.getModelList;
            return this.http.get({
                url,
                params: extra,
                data: {
                    ts: dayjs(),
                },
            });
        };
        /**
         * 添加新的Modal
         * @param model_name
         * @returns
         */
        this.putAddModelItem = (model_name) => {
            const url = this.urls.putAddModelItem;
            return this.http.put({
                url,
                params: extra,
                data: {
                    model_name: model_name,
                },
            });
        };
        /**
         * 删除Modal 删除失败
         * @param groupName
         * @returns
         */
        this.deleteModelItem = (groupName) => {
            const url = this.urls.deleteModelItem;
            return this.http.delete({
                url,
                params: {
                    groupName,
                },
            });
        };
        /**
         * 获取表格数据
         * @param pageIndex
         * @param pageSize
         * @returns
         */
        this.postGetConfigList = (pageIndex, pageSize) => {
            return this.http.post({
                url: this.urls.postGetConfigList,
                data: {
                    options: {},
                    page: pageIndex,
                    size: pageSize,
                },
            });
        };
        /**
         * 导入配置 有问题
         * @param params
         * @returns
         */
        this.putImportConfig = (params) => {
            const url = this.urls.putImportConfig;
            return this.http.put({
                url,
                params: extra,
                data: {
                    ...params,
                    params: params.params ? JSON.stringify(params.params) : params.params,
                    value: params.value ? JSON.stringify(params.value) : params.value,
                },
            });
        };
        /**
         * 删除表格项
         * @param key
         * @returns
         */
        this.deleteConfig = (key) => {
            const url = this.urls.deleteConfig;
            return this.http.delete({
                url,
                params: {
                    key,
                },
            });
        };
        /**
         * 编辑获取详情
         * @param key
         * @returns
         */
        this.getConfigDetail = (key) => {
            const url = this.urls.getConfigDetail;
            return this.http.get({
                url,
                params: {
                    key,
                },
            });
        };
        /**
         * 创建配置
         * @param params
         * @returns
         */
        this.putAddConfigDetail = (params) => {
            const url = this.urls.putAddConfigDetail;
            return this.http.put({
                url,
                params: extra,
                data: {
                    ...params,
                    params: params.params ? JSON.stringify(params.params) : params.params,
                    value: params.value ? JSON.stringify(params.value) : params.value,
                },
            });
        };
        /**
         * 更新配置
         * @param params
         * @returns
         */
        this.putUpdateConfig = (params) => {
            const url = this.urls.putUpdateConfig;
            return this.http.put({
                url,
                params: { key: params.key },
                data: {
                    ...params,
                    params: params.params ? JSON.stringify(params.params) : params.params,
                    value: params.value ? JSON.stringify(params.value) : params.value,
                },
            });
        };
    }
};
CmsApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.CmsUrls)),
    __param(1, inject(Symbols.BoHttp)),
    __metadata("design:paramtypes", [Object, Object])
], CmsApi);
export { CmsApi };
